"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowBreakpoint = void 0;
var WindowBreakpoint;
(function (WindowBreakpoint) {
    WindowBreakpoint["Xs"] = "xs";
    WindowBreakpoint["GtXs"] = "gtXs";
    WindowBreakpoint["Sm"] = "sm";
    WindowBreakpoint["GtSm"] = "gtSm";
    WindowBreakpoint["Md"] = "md";
    WindowBreakpoint["GtMd"] = "gtMd";
    WindowBreakpoint["Lg"] = "lg";
    WindowBreakpoint["GtLg"] = "gtLg";
    WindowBreakpoint["Xl"] = "xl";
})(WindowBreakpoint || (exports.WindowBreakpoint = WindowBreakpoint = {}));
